/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    V1ExecAction,
    V1ExecActionFromJSON,
    V1ExecActionFromJSONTyped,
    V1ExecActionToJSON,
} from './V1ExecAction';
import {
    V1HTTPGetAction,
    V1HTTPGetActionFromJSON,
    V1HTTPGetActionFromJSONTyped,
    V1HTTPGetActionToJSON,
} from './V1HTTPGetAction';
import {
    V1SleepAction,
    V1SleepActionFromJSON,
    V1SleepActionFromJSONTyped,
    V1SleepActionToJSON,
} from './V1SleepAction';
import {
    V1TCPSocketAction,
    V1TCPSocketActionFromJSON,
    V1TCPSocketActionFromJSONTyped,
    V1TCPSocketActionToJSON,
} from './V1TCPSocketAction';

/**
 * LifecycleHandler defines a specific action that should be taken in a lifecycle
 * hook. One and only one of the fields, except TCPSocket must be specified.
 * @export
 * @interface V1LifecycleHandler
 */
export interface V1LifecycleHandler {
    /**
     * 
     * @type {V1ExecAction}
     * @memberof V1LifecycleHandler
     */
    exec?: V1ExecAction;
    /**
     * 
     * @type {V1HTTPGetAction}
     * @memberof V1LifecycleHandler
     */
    httpGet?: V1HTTPGetAction;
    /**
     * 
     * @type {V1SleepAction}
     * @memberof V1LifecycleHandler
     */
    sleep?: V1SleepAction;
    /**
     * 
     * @type {V1TCPSocketAction}
     * @memberof V1LifecycleHandler
     */
    tcpSocket?: V1TCPSocketAction;
}

export function V1LifecycleHandlerFromJSON(json: any): V1LifecycleHandler {
    return V1LifecycleHandlerFromJSONTyped(json, false);
}

export function V1LifecycleHandlerFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1LifecycleHandler {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exec': !exists(json, 'exec') ? undefined : V1ExecActionFromJSON(json['exec']),
        'httpGet': !exists(json, 'httpGet') ? undefined : V1HTTPGetActionFromJSON(json['httpGet']),
        'sleep': !exists(json, 'sleep') ? undefined : V1SleepActionFromJSON(json['sleep']),
        'tcpSocket': !exists(json, 'tcpSocket') ? undefined : V1TCPSocketActionFromJSON(json['tcpSocket']),
    };
}

export function V1LifecycleHandlerToJSON(value?: V1LifecycleHandler | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exec': V1ExecActionToJSON(value.exec),
        'httpGet': V1HTTPGetActionToJSON(value.httpGet),
        'sleep': V1SleepActionToJSON(value.sleep),
        'tcpSocket': V1TCPSocketActionToJSON(value.tcpSocket),
    };
}

